export default "__VITE_ASSET__75048d3a__"